<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div v-if="datum" class="innerWrapper">
      <h1>Reserved properties</h1>
      <div
        v-if="datum.totalRecord == 0"
        style="padding-top:80px;text-align:center;font-size:18px;color:#3F3F46;margin-bottom:218px"
      >
        No data.
      </div>
      <pagination
        v-if="datum.totalRecord !== 0"
        :cur="pageCur"
        v-bind:total="datum.totalRecord"
        @accept="page"
      ></pagination>
      <ul>
        <li v-for="(item, index) in datum.formatList" :key="index">
          <item
            :btnNum="index + 1"
            :cur="pageCur"
            :datum="item"
            :tag="false"
            @accept="collectOperate"
          ></item>
        </li>
      </ul>
      <pagination
        v-if="datum.totalRecord !== 0"
        :cur="pageCur"
        v-bind:total="datum.totalRecord"
        @accept="page"
      ></pagination>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import item from "@/components/package/item";
import pagination from "@/components/package/pagination";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      gray: true,
      hidePrice: false,
      pageCur: 1,
      pageSize: 8
    };
  },
  created() {
    var that = this;
    if (
      sessionStorage.getItem("rpage") &&
      sessionStorage.getItem("rpage") !== null &&
      sessionStorage.getItem("rpage") !== undefined
    ) {
      this.pageCur = parseInt(sessionStorage.getItem("rpage"));
      sessionStorage.removeItem("rpage");
    }
    that.getLst({
      params: { page: that.pageCur, pageSize: that.pageSize },
      callback: that.callback
    });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    collectOperate(type, id) {
      var that = this;
      if (type == "no") {
        that.postCollect({
          params: { propertyId: id },
          callback: that.collcectCallback
        });
      } else {
        that.cancelCollect({
          params: { propertyId: id },
          callback: that.cancelCallback
        });
      }
    },
    collcectCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "no", id: id } });
        that.$forceUpdate();
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    cancelCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "yes", id: id } });
        that.$forceUpdate();
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    ...mapActions("home", ["postCollect", "cancelCollect"]),
    ...mapActions("reserve", ["getLst"]),
    ...mapMutations("reserve", ["setLst", "collect"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        // 统一把列表格式化
        res.data.data.formatList = [];
        res.data.data.list.forEach(v => {
          if (v.housePropertyPOJO.imageUrl) {
            if (v.housePropertyPOJO.imageUrl.indexOf(",") !== -1) {
              v.housePropertyPOJO.imgLst = v.housePropertyPOJO.imageUrl.split(
                ","
              );
            } else {
              v.housePropertyPOJO.imgLst = [v.housePropertyPOJO.imageUrl];
            }
          }
          // 把所有房间号加进去
          if (v.houseRoomPojosList.length > 0) {
            res.data.data.formatList.push({
              propertyId: v.housePropertyPOJO.propertyId,
              imgLst: v.housePropertyPOJO.imgLst,
              address: v.housePropertyPOJO.address,
              suburb: v.housePropertyPOJO.suburb,
              price:
                v.houseRoomPojosList[0].revisedPrice !== ""
                  ? that.$box.formatSplit(
                      v.houseRoomPojosList[0].revisedPrice,
                      true
                    )
                  : "",
              rental: that.$box.formatSplit(v.housePropertyPOJO.rental, true),
              maxRental: that.$box.formatSplit(
                v.housePropertyPOJO.maxRental,
                true
              ),
              rentalYield: v.housePropertyPOJO.rentalYield,
              commision: that.$box.formatSplit(
                parseInt(v.housePropertyPOJO.commission),
                true
              ),
              maxCommision:
                v.housePropertyPOJO.maxCommision !== ""
                  ? that.$box.formatSplit(
                      parseInt(v.housePropertyPOJO.maxCommision),
                      true
                    )
                  : "",
              // bedsNumber: (v.housePropertyPOJO.proertyType == 'Apartments Units' || v.housePropertyPOJO.proertyType == 'Townhouses') ? v.houseRoomPojosList[0].beds : v.housePropertyPOJO.bedsNumber,
              bedsNumber: v.houseRoomPojosList[0].beds
                ? v.houseRoomPojosList[0].beds
                : "",
              favoritesFlag: v.favoritesFlag,
              proertyType: v.housePropertyPOJO.proertyType,
              // roomId: (v.housePropertyPOJO.proertyType == 'Apartments Units' || v.housePropertyPOJO.proertyType == 'Townhouses') ? v.houseRoomPojosList[0].roomId : undefined,
              roomId: v.houseRoomPojosList[0].roomId
                ? v.houseRoomPojosList[0].roomId
                : undefined,
              state: v.housePropertyPOJO.state,
              postcode: v.housePropertyPOJO.postcode,
              // apt: (v.housePropertyPOJO.proertyType == 'Apartments Units' || v.housePropertyPOJO.proertyType == 'Townhouses') ? v.houseRoomPojosList[0].apt : '',
              apt: v.houseRoomPojosList[0].apt
                ? v.houseRoomPojosList[0].apt
                : "",
              // 多传一个判断状态
              sellFlag: 1, // 判断跳转到详情
              operate: 1,
              orderId: v.ordersId && v.ordersId !== "" ? v.ordersId : null,
              clickFlag: true,
              estimatedCompletion: v.housePropertyPOJO.estimatedCompletion,
              estimatedCommenceMent: v.housePropertyPOJO.estimatedCommenceMent,
              landPrice:
                v.housePropertyPOJO.landPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.landPrice, true)
                  : "",
              buildPrice:
                v.housePropertyPOJO.buildPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.buildPrice, true)
                  : "",
              incentives: v.housePropertyPOJO.incentives,
              ordersId: v.ordersId && v.ordersId !== "" ? v.ordersId : null
            });
          }
        });
        that.setLst({ data: res.data.data });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    page(p) {
      var that = this;
      that.pageCur = p;
      that.getLst({
        params: { page: that.pageCur, pageSize: that.pageSize },
        callback: that.callback
      });
      document.getElementById("top").scrollIntoView();
    }
  },
  components: {
    headNav,
    footNav,
    item,
    pagination
  },
  computed: {
    ...mapState({
      datum: state => state.reserve.list
    })
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    padding-left: 0.32rem;
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.8rem;
    font-family: ProximaNova-Semibold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/reserve.vue